import React from 'react';
import {Modal} from "../../../../components/modal/modal.jsx";
import {Card} from "../../../../components/card/card.jsx";
import {FaAddressBook} from "react-icons/fa6";
import {getAssetPath} from "../../../../utils/get-asset-path.js";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {downloadAnyDesk} from "../utils/login-utils.js";

const TechnicalSupportModal = ({open, setOpen}) => {
    const navigate = navigateHook();

    const openContacts = () => navigate("/contacts", true);

    return (
        <Modal
            open={open}
            setOpen={() => setOpen(false)}
            className="w-[400px] max-w-full !bg-[#031B34] [&>div]:!bg-[#031B34] [&>div]:!border-0 [&>div]:!shadow-none"
            headerClass="!border-0 text-white"
            title={<img src={getAssetPath("img/favicon.ico")} alt="Sentry" className="w-[20px]"/>}
        >
            <Modal.Body>
                <p className="text-center text-[#ffca28] font-semibold text-[15px] mb-3">Suporte - Sentry</p>

                <div className="flex gap-3 justify-center">
                    <Card className="w-[130px] cursor-pointer hover:bg-gray-50" onClick={openContacts}>
                        <Card.Body className="flex flex-col items-center gap-2 text-center">
                            <FaAddressBook className="text-[3.5rem] text-gray-700"/>
                            <span className="text-[14px]">Suporte</span>
                        </Card.Body>
                    </Card>

                    <Card className="w-[130px] cursor-pointer hover:bg-gray-50" onClick={downloadAnyDesk}>
                        <Card.Body className="flex flex-col items-center gap-2 text-center">
                            <img src={getAssetPath("img/dashboard-svg/sw.anydesk.svg")} alt="AnyDesk" className="w-[3.5rem] h-[3.5rem] object-contain"/>
                            <span className="text-[14px]">Baixar AnyDesk</span>
                        </Card.Body>
                    </Card>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default TechnicalSupportModal;
